export function OnboardingSectionHeading({ icon: Icon, label }) {
  return (
    <div className="mb-4 flex items-center gap-2">
      <Icon className="h-4 w-4 text-[#f19500]" aria-hidden />
      <h2 className="text-sm font-bold text-[#1B1B2F]">{label}</h2>
    </div>
  );
}
